G.DirtS = function(layer, cellX, cellY, hp) {
  G.BoardToken.call(this, layer, {
    tokenType: "dirtS",
  }, cellX, cellY, hp);

  G.changeTexture(this, "dirt_s_"+this.hp);

  this.top
};

G.DirtS.prototype = Object.create(G.BoardToken.prototype);

G.DirtS.prototype.onMatch = function() {

  G.sb("hitDirtS").dispatch(this);
  G.sb("fxTop").dispatch('burstDirtAnim',this,this);
  this.hp--;
  if (this.hp > 0) {
    G.changeTexture(this,'dirt_s_'+this.hp);
  }else {
    this.remove();
  }
};

G.DirtS.prototype.increaseHp = function() {
  this.hp++;
  G.changeTexture(this,'dirt_s_'+this.hp);
};

G.DirtS.prototype.onBooster = function() {
  this.onMatch();
  return false;
};